'use client'

import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { createDynamicComponent } from '@/utils/factoryUtil'

const MenuNav = createDynamicComponent({
  loader: () => import('@/components/layout/Menu'),
  loading: false,
  name: 'MenuNav',
})

const MenuClipboard = createDynamicComponent({
  loader: () => import('@/components/layout/Menu'),
  loading: false,
  name: 'MenuClipboard',
})

export const MenusMobile = () => {
  const { isDesktop, loading } = useBreakpoints()

  return (
    !isDesktop &&
    !loading && (
      <>
        <MenuClipboard />
        <MenuNav />
      </>
    )
  )
}
